import useManualQuery from '@/data/hook/query/v1/useManualQuery';
import { ListAlertsFilters, updateAlert } from '@/data/services/alertServices';
import { alertQueryKeys } from '@/data/services/querykeys';
import { Alert, AlertTypeEnum } from '@/models/Alert';
import { createWhatsappLink } from '@/utils/communication/messageApps';
import { ROUTES } from '@/utils/routes';
import NotificationActions from '../action/NotificationActions';
import OcurrenceNotificationDetail from '../detail/OcurrenceNotificationDetail';
import NotificationCard from './NotificationCard';

type OccurrenceNotificationCardProps = {
  notification: Alert & { type: AlertTypeEnum.OCCURRENCE };
  filters: ListAlertsFilters;
};

export type HandleSendMessageArgs = {
  phoneNumber: string;
  text: string;
};

export default function OccurrenceNotificationCard(
  props: OccurrenceNotificationCardProps,
) {
  const { notification, filters } = props;

  const extraInfo = notification.extraInfo;

  const { update } = useManualQuery(alertQueryKeys.list(filters)._ctx.infinity);

  const link = ROUTES.ADMIN.STUDENTS.INFO({
    idIn: notification.actor.id.toString(),
  });

  const handleMarkAsRead = async (notificationId: number, isRead: boolean) => {
    const updatedNotification = await updateAlert(notificationId, {
      isRead,
    });
    update(updatedNotification);
  };

  const handleSendMessage = ({ phoneNumber, text }: HandleSendMessageArgs) => {
    const link = createWhatsappLink(phoneNumber, {
      text,
    });
    window.open(link, '_blank')?.focus();
  };

  const handleAddComment = async (id: number, comment: string) => {
    const updatedAlert = await updateAlert(id, { comment });
    update(updatedAlert);
  };

  return (
    <NotificationCard
      actor={{
        text: notification.actor.title,
        link,
      }}
      notification={notification}
      onMarkAsRead={handleMarkAsRead}
      detail={<OcurrenceNotificationDetail target={extraInfo} />}
      actions={
        <NotificationActions
          onSendMessage={handleSendMessage}
          onAddComment={handleAddComment}
          notification={notification}
        />
      }
    />
  );
}
